// import utils from './utils'
// let rootPath = process.env.STATIC_PATH
// if(imageConfig)
// let imageConfig =
import { updateConsentGA } from '../utils/eu_popup'

export const imageMixin = {
  data() {
    return {
      imageConfig: {
        diamond: '',
        toastBg: '',
        dialogBg: '',
        dialogClose: '',
        dialogBtn: '',
        dialogLine: '',
      },
    }
  },
  methods: {
    customImgUrl(imgkey) {
      if (imgkey.indexOf('/') > 0) {
        return `background-image: url(${imgkey});`
      } else {
        return `background-image: url(${this.imageConfig[imgkey]});`
      }
    },
    updateConsentGA
  },
  created() {
    // // console.log(require.cache)
    // console.log(this.imageConfig.historyArrow)
    // console.log(imageConfig.bigRewardBg)
    if (this.globalConfig && this.globalConfig.userInfo && this.globalConfig.userInfo.custom_imgs) {
      this.imageConfig = this.globalConfig.userInfo.custom_imgs
      // let imgKeys = Object.keys(this.imageConfig)
      //           imgKeys.forEach(ele => {
      //                   if (this.globalConfig.userInfo.custom_imgs[ele]) {
      //                       this.imageConfig[ele] = this.globalConfig.configData.images[ele]
      //                   }
      //         })
      // let imgKeys = Object.keys(this.imageConfig)
      // imgKeys.forEach(ele=>{
      //   if(this.globalConfig.userInfo.custom_imgs[ele]){
      //     this.imageConfig[ele] = this.globalConfig.userInfo.custom_imgs[ele]
      //   }
      // })
      // // console.log(this.imageConfig)
      // Object.assign(this.imageConfig,this.globalConfig.configData.images)
    }
    // console.log(this.globalConfig)
  }
}
// 倒计时
export const set_count_down = {
  data() {
    return {
      countTime: {
        DAYS: '--',
        HOURS: '--',
        MINUTES: '--',
        SECONDS: '--'
      },
    }
  },
  methods: {
    setCountDown(endTime) {
      // console.log(endTime)
      var _this = this;
      var nowDate, endDate, timer, leftTime;
      var d, h, m, s

      function addZero(i) {
        if (i < 10) {
          i = "0" + i;
        }
        return i;
      }

      timer = setInterval(function () {
        nowDate = new Date().getTime();
        endDate = endTime * 1000;
        if (endDate < nowDate) {
          clearInterval(timer)
          timer = null
          return 'arrival'
        }
        if (endDate > nowDate) {
          leftTime = parseInt((endDate - nowDate) / 1000);
          d = parseInt(leftTime / (24 * 60 * 60));
          h = addZero(parseInt(leftTime / (60 * 60) % 24));
          m = addZero(parseInt(leftTime / 60 % 60));
          s = addZero(parseInt(leftTime % 60));
        }
        _this.countTime = {
          DAYS: d,
          HOURS: h,
          MINUTES: m,
          SECONDS: s
        }
      }, 1000);
    }
  },
}



// WEBPACK FOOTER //
// ./src/mixins/index.js